<template>
  <div class="calendar-stub text-body-1">
    {{ t('Запись недоступна', options) }}
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.calendar-stub {
  width: 100%;
  padding: 50px 0;
  border-radius: $border-radius-sm;
  background-color: $ui-kit-bg-gray-40;
  color: $ui-kit-text-secondary;
  text-align: center;
}
</style>
